import Icon from '@bugbug/core/components/Icon';
import styled from 'styled-components';

export const Container = styled.div``;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -26px;
  padding-top: 17px;
  padding-bottom: 27px;
  min-height: 104px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const PriceTaxInfo = styled.span`
  margin-left: 16px;
  color: ${(props) => props.theme.colors.text.secondary};
  font-weight: ${(props) => props.theme.fontWeight.regular};
  font-size: 13px;
  margin-top: 4px;
`;

export const PlansGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 30px;
  justify-content: stretch;
`;

export const RadioGroup = styled.div`
  font-weight: ${(props) => props.theme.fontWeight.semibold};
  background-color: ${(props) => props.theme.colors.background.highlight};
  padding: 9px 16px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
`;

export const Discount = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  text-transform: uppercase;
  margin-left: 4px;
  padding: 0 4px;
`;

export const SubscriptionStatus = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 80px;
`;

export const HelperIcon = styled(Icon).attrs(() => ({
  name: 'help',
}))`
  display: inline-block;
  width: 14px;
  transform: translateY(-1px);
  color: ${(props) => props.theme.colors.text.subtle};
  margin-left: 2px;
`;
